<template>
    <div class="dashboard-offers-and-promotions-box">
        <div class="main-rotating-banner-wrapper">
            <slider ref="slider" :options="slider_options">
                <template slot-scope="coverflow">
                    <slideritem :pageLength="5" :index="0" :key="0" :style="slider_style">
                        <div class="dashboard-grid-panel _fuelcard">
                            <div class="cols">
                                <div class="col-info">
                                    <div class="inner-box">
                                        <div class="title">
                                            WE FIND THE BEST <strong>FUEL CARD</strong> FOR YOUR BUSINESS
                                        </div>
                                        <div>
                                            <a class="btn-default" href="/offers-and-promotions/fuel-card">
                                                Find out more
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-image">
                                    <img src="/images/dashboard-banner-card-fuelcard.png">
                                </div>
                            </div>
                        </div>
                    </slideritem>
                    <slideritem :pageLength="5" :index="1" :key="1" :style="slider_style">
                      <div class="dashboard-grid-panel _tradepoint">
                        <div class="cols">
                          <div class="col-info">
                            <div class="inner-box">
                                <div class="title">
                                    DISCOUNT CARD IN PARTNERSHIP WITH <strong>TRADEPOINT!</strong>
                                </div>
                              <div>
                                <a class="btn-default" href="/offers-and-promotions/tradepoint">
                                  Find out more
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="col-image">
                            <img src="/images/dashboard-banner-card-tradepoint.png">
                          </div>
                        </div>
                      </div>
                    </slideritem>
                    <slideritem :pageLength="5" :index="2" :key="2" :style="slider_style">
                      <div class="dashboard-grid-panel _brandhub">
                        <div class="cols">
                          <div class="col-info">
                            <div class="inner-box">
                                <div class="title">
                                    DISCOUNTED WORKWEAR WITH <strong>YOUR LOGO</strong>
                                </div>
                              <div>
                                <a class="btn-default" href="/offers-and-promotions/branded-workwear">
                                  Find out more
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="col-image">
                            <img src="/images/dashboard-banner-card-brandhub.png">
                          </div>
                        </div>
                      </div>
                    </slideritem>
                    <slideritem :pageLength="5" :index="3" :key="3" :style="slider_style">
                        <div class="dashboard-grid-panel _training">
                            <div class="cols">
                                <div class="col-info">
                                    <div class="inner-box">
                                        <div class="title">
                                            Browse our NVQ's, Apprenticeships, Classroom and Virtual Learning Courses
                                        </div>
                                        <div>
                                            <a class="btn-default" href="/training">
                                                Find out more
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-image">
                                    <img src="/images/dashboard-banner-card-mrg-training.png">
                                </div>
                            </div>
                        </div>
                    </slideritem>
                  <slideritem :pageLength="5" :index="4" :key="4" :style="slider_style">
                    <div class="dashboard-grid-panel _what-would-you-like-to-see">
                      <div class="cols">
                        <div class="col-info">
                          <div class="inner-box">
                            <div class="title">
                              HAVE YOU GOT ANYTHING YOU WOULD LIKE TO SEE ON <strong>CONNECT</strong>?
                            </div>
                            <div>
                              <a class="btn-default" @click="$emit('openwhatwouldyouliketoseebox')">
                                Let us know!
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="col-image">
                          <img src="/images/dashboard-banner-card-what-would-you-like-to-see.png">
                        </div>
                      </div>
                    </div>
                  </slideritem>
                </template>
                <!-- Customizable loading -->
                <div slot="loading">loading...</div>
            </slider>
        </div>
    </div>
</template>

<script>
  // import slider components
  import {slider, slideritem} from 'vue-concise-slider'

  export default {
    data() {
      return {
        slider_style: "'width': '100%'",
        //Slider configuration [obj]
        slider_options: {
          currentPage: 0,
          thresholdDistance: 100,
          thresholdTime: 1000,
          deviation: 200,
          widthScalingRatio: 0.8,
          heightScalingRatio: 0.8,
          slidesToScroll: 1,
          loop: true,
          autoplay:'5000',
          renderPagination: (h, index) => {
            return h('div', {
              class: `pagination-bullet bullet-${index}`,
            }, [])
          },
          pagination: true
        }
      }
    },
    methods: {
    },
    components: {
      slider,
      slideritem
    }
  }
</script>
